import util from '@/common/util';
import { defaultCurrencyObj, defaultLngCode } from './constant';
import Data from '@/common/data';
const localLngKey = 'chimetrans';
const localCurrencyKey = 'chime_currency';
const localCurrencySymbol = 'chime_currency_symbol';
const localLanguage = {
    getFromGlobalData(Data) {
        let trans = util.getCookie(localLngKey);
        if (
            trans &&
            (Data.sysLanguageList || []).map(v => v.language).includes(trans)
        ) {
            return trans;
        }
        return defaultLngCode;
    },
    get() {
        return util.getCookie(localLngKey);
    },
    set(lang) {
        util.setCookie(localLngKey, lang);
    }
};

const currencyData = {
    initFromData: false,
    initFromCookie: false,
    abbr: '',
    name: '',
    symbol: ''
};

function updateCurrencyData(data) {
    currencyData.abbr = data.abbr;
    currencyData.name = data.name;
    currencyData.symbol = data.symbol;
    currencyData.init = true;
    return currencyData;
}

function rectifyCurrencyCookie(sourceCurrency) {
    const targetCurrency = defaultCurrencyObj.abbr;
    if (sourceCurrency == targetCurrency) {
        return;
    }
    //本地存储的currency cookie，在siteCurrencyList找不到，本地cookie也要纠正为default
    //后端fetcher需要用到cookie中的chime_currency，因为是jsp阶段使用
    console.log(
        '\x1B[35m%s\x1B[0m',
        `Reset cookie chime_currency ${sourceCurrency} => ${targetCurrency}`
    );
    localCurrency.set(defaultCurrencyObj);
    window.siteAppVm.$EventBus.$emit('changeCurrency', targetCurrency);
    //cookie值纠正时需要刷新，否则非xhr部分请求返回内容会有问题
    window.location.reload();
}

function initCurrencyData() {
    if (currencyData.initFromData) {
        return;
    }
    if (currencyData.initFromCookie && !('openMultilingual' in Data)) {
        return;
    }
    let currencyCode = util.getCookie(localCurrencyKey);
    if (!('openMultilingual' in Data)) {
        if (!currencyCode) {
            updateCurrencyData(defaultCurrencyObj);
        } else {
            currencyData.abbr = currencyCode;
            currencyData.symbol = decodeURIComponent(
                util.getCookie(localCurrencySymbol) || ''
            );
        }
        currencyData.initFromCookie = true;
        return;
    }
    currencyData.initFromData = true;
    if (
        !currencyCode ||
        !Data.openMultilingual ||
        !Data.siteCurrencyList ||
        !Data.siteCurrencyList.length
    ) {
        return updateCurrencyData(defaultCurrencyObj);
    }
    let currencyList = Data.siteCurrencyList;
    for (let i = 0; i < currencyList.length; i++) {
        if (currencyList[i].abbr == currencyCode) {
            return updateCurrencyData(currencyList[i]);
        }
    }
    rectifyCurrencyCookie(currencyCode);
    return updateCurrencyData(defaultCurrencyObj);
}

const localCurrency = {
    get() {
        initCurrencyData();
        return currencyData.abbr;
    },
    getObj() {
        initCurrencyData();
        return { ...currencyData };
    },
    getSymbol() {
        initCurrencyData();
        return currencyData.symbol;
    },
    set({ abbr, symbol }) {
        util.setCookie(localCurrencyKey, abbr);
        util.setCookie(
            localCurrencySymbol,
            symbol && encodeURIComponent(symbol)
        );
    }
};

export { localLanguage, localCurrency };
